export default {
  'overview_daily_Daily': 'Daily',
  'overview_daily_DAU': 'DAU',
  'overview_daily_D2': 'D2',
  'overview_daily_D2/3/7': 'D2/3/7',
  'overview_daily_D2(T-1)': 'D2(T-1)',
  'overview_daily_D3': 'D3',
  'overview_daily_D7': 'D7',
  'overview_daily_D14': 'D14',
  'overview_daily_D21': 'D21',
  'overview_daily_D28': 'D28',
  'overview_daily_D30': 'D30',
  'overview_daily_D4': 'D4',
  'overview_daily_D5': 'D5',
  'overview_daily_D6': 'D6',
  'overview_daily_DAU_Retention_Users': 'DAU Retention Users',
  'overview_daily_DAU_Return_Users': 'DAU Return Users',
  'overview_daily_weighted_tab': 'Weighted D2/D3/D7',
  // 'overview_daily_Weighted_D1':'Weighted D1',
  'overview_daily_Weighted_D2': 'Weighted D2',
  'overview_daily_Weighted_D3': 'Weighted D3',
  'overview_daily_Weighted_D7': 'Weighted D7',
  'overview_daily_Weighted_D2_short': 'WD2',
  'overview_daily_Weighted_D3_short': 'WD3',
  'overview_daily_Weighted_D7_short': 'WD7',
  'overview_day_Weighted_2': 'Weighted D2',
  'overview_day_Weighted_3': 'Weighted D3',
  'overview_day_Weighted_7': 'Weighted D7',
  'overview_daily_Weighted_D14': 'Weighted D14',
  'overview_daily_Weighted_D21': 'Weighted D21',
  'overview_daily_Weighted_D28': 'Weighted D28',
  'overview_daily_Weighted_D30': 'Weighted D30',
  'overview_daily_1st_Order_Login%': '1st Order Login%',
  'overview_daily_2nd_Order_Login%': '2nd Order Login%',

  // v2趋势图
  'overview_daily_v2_playtime': 'Md.Playtime',
  'overview_daily_v2_avg_playtime': 'Avg.Playtime',
  'overview_daily_v2_session': 'Md.Playtime Per Save',
  'overview_daily_v2_avg_session': 'Avg.Playtime Per Save',

  // 卡片
  'overview_daily_key_performance_metrics_explain_au': 'Daily Active Users.Number of users who have logged in to the game during the statistical period (vopenid deduplicated).Date more than 1 day shows averageDAU.',
  'overview_daily_key_performance_metrics_explain_new': 'New Register Users.Total number of newly-registered users in the statistical period (vopenid deduplicated).Date more than 1 day shows sum new.',
  'overview_daily_key_performance_metrics_explain_revenue': 'Count the total amount actually paid by the current players.Date more than 1 day shows sum revenue.',
  'overview_daily_key_performance_metrics_explain_arpu': 'Average Revenue Per Active Users.Consumption amount/Number of active users in the statistical period.<br/>Date more than 1 day shows average ARPU.Sum of consumption amount in the statistical period /Sum of active users in the statistical period.',
  'overview_daily_key_performance_metrics_explain_payer': 'Number of paying users/Number of active users during the statistical period.<br/>Date more than 1 day shows average payer%.Sum of payers in the statistical period / Sum of active users in the statistical period.',
  'overview_daily_key_performance_metrics_explain_d2': 'The retention rate of new register users  on day 2.<br/>D2:Number of retained users on day 2 from registration date/ Number of new users on registration date. Registration date is day 1.<br/>Date more than 1 day shows average D2. Sum of retention users on day 2 in the statistical period / Sum of new register users in the statistical period.<br/>T-1 stands for the day before the statistics day.',

  // TODO: 无
  'overview_day_retention_2': 'D2',
  'overview_day_retention_3': 'D3',
  'overview_day_retention_7': 'D7',
  'overview_daily_Last_Week': 'SDLW',
  'overview_daily_Last_Month': 'SDLM',
  'overview_daily_Last_Year': 'SDLY',
  'overview_daily_Today': 'Today',
  'overview_daily_DAU_Breakdown': 'DAU Breakdown',

  'overview_table_date': 'Date',
  'overview_table_new_users': 'New Users',

  'overview_overall_performance': 'Overall Performance',
  'overview_overall_performance_version': 'By Version',

  'overview_breakdown_legend1': 'New Users',
  'overview_breakdown_legend2': 'Retention Users',
  'overview_breakdown_legend3': 'Return Users',

  'overview_area_title': 'Country/Region/Zone Breakdown',
  'overview_area_tab_country': 'Country',
  'overview_area_tab_region': 'Region',
  'overview_area_tab_zone': 'Zone',
  'overview_area_tab_channel': 'Channel',
  'overview_area_title_country': '{timeType} of Top 10 Countries',
  'overview_area_title_region': '{timeType} of Top 10 Regions',
  'overview_area_title_zone': '{timeType} of Top 10 Zones',
  'overview_area_title_channel': '{timeType} of Top 10 Channel',
  'overview_area_title_os1': '{timeType} of Top 10 Platform',
  'overview_area_active_table_header2': '{timeType}AU',
  'overview_area_active_table_header2_avg': 'Avg.{timeType}AU',
  'overview_area_active_table_header3': 'Share of All',

  'overview_area_revenue_table_header2_sum': 'Sum Revenue',
  'overview_area_revenue_table_header2': 'Revenue',
  'overview_area_mtx_revenue_table_header2_sum': 'Sum In-Game Revenue',
  'overview_area_mtx_revenue_table_header2': 'In-Game Revenue',
  'overview_area_new_table_header2_sum': 'Sum New',
  'overview_area_new_table_header2': 'New',
  'overview_area_units_table_header2_sum': 'Sum Base Game Units After Refund',
  'overview_area_units_table_header2': 'Base Game Units After Refund',
  'overview_area_net_revenue_table_header2_sum': 'Sum Revenue After Refund & Tax',
  'overview_area_net_revenue_table_header2': 'Revenue After Refund & Tax',
  'overview_area_new_chart_share': 'Share',

  // PC Console 模块
  'overview_pcconsoleday_retention_2': 'D2',
  'overview_pcconsoleday_retention_3': 'D3',
  'overview_pcconsoleday_retention_7': 'D7',
  'overview_pcconsoleday_Weighted_2': 'Weighted D2',
  'overview_pcconsoleday_Weighted_3': 'Weighted D3',
  'overview_pcconsoleday_Weighted_7': 'Weighted D7',
  'overview_area_tab_os': 'Platform',
  'overview_area_tab_lang': 'Language',
  'overview_area_title_os': '{timeType} of Platform',
  'overview_area_title_lang': '{timeType} of Language',
  // 卡片
  'pc_overview_daily_key_performance_metrics_explain_revenue': 'During the statistical period, the total net sales revenue of sales platforms includes Steam/Epic/Playstation/Xbox and other platforms. Data Source: Platform Sales Reports',
  'pc_overview_daily_key_performance_metrics_explain_units': 'During the statistical period, the net sales of the game itself include sales of full game, edition, etc. Data Source: Platform Sales Reports',
  'pc_overview_daily_key_performance_metrics_explain_aot': 'Average Playtime Time.Total online time/Number of active users (min).',
  'pc_overview_daily_key_performance_metrics_explain_pcu': 'The highest number of users online simultaneously at each moment (every 5 minutes) of the day.',
  'pc_overview_daily_key_performance_metrics_explain_dlc_mtx_revenue': 'The total amounts from download content and microtransactions in the statistical period.',
  'pc_overview_daily_key_performance_metrics_explain_mtx_revenue': 'The total amounts from microtransactions whtin the statistical period.',
  'pc_overview_daily_key_performance_metrics_explain_mtx_payer_rate': 'Number of In-Game paying users/Number of active users during the statistical period.',
  'pc_overview_daily_key_performance_metrics_explain_mtx_payer': 'Total number of users who have in-game payment behaviors in the statistical period (deduplicated).',
  'pc_overview_daily_key_performance_metrics_explain_payer': 'Total number of users who have payment behaviors in the statistical period, including in-game payment and DLC. (deduplicated).',
  'pc_overview_daily_key_performance_metrics_explain_payer%': 'Number of In-Game and DLC paying users/Number of active users during the statistical period.',
  'pc_overview_daily_key_performance_metrics_explain_dlc_mtx_arpu': 'DLC&In-Game Revenue/Number of active users during the statistical period.',
  'pc_overview_daily_key_performance_metrics_explain_mtx_arpu': 'In-Game Revenue/Number of active users during the statistical period.',
  'pc_overview_daily_key_performance_metrics_explain_arppu': 'Total Revenue/Number of DLC+In-Game pay users during the statistical period.',
  'pc_overview_daily_key_performance_metrics_explain_dlc_mtx_arppu': 'DLC&In-Game Revenue/Number of pay users during the statistical period.',
  'pc_overview_daily_key_performance_metrics_explain_mtx_arppu': 'In-Game Revenue/Number of pay users during the statistical period.',

  // Nightingale
  'pc_overview_daily_D1': 'D1',
  'pc_overview_daily_D2': 'D2',
  'pc_overview_daily_key_performance_metrics_explain_accumulated_units': 'Game sales of copies from the game launch to the end of the statistical date.',
  'pc_overview_daily_key_performance_metrics_explain_refunded_units': 'Game refunded of copies in statistical period.',
  'pc_overview_daily_key_performance_metrics_explain_accumulated_revenue': 'Total amounts  from the game launch to the end of the statistical date.',
  'pc_overview_daily_key_performance_metrics_explain_avg_selling_price_asp': 'Average selling price of games during the statistical period.',
  'pc_overview_daily_key_performance_metrics_explain_reactivated_users': 'Active users with more than 30 days since their last login.',
  'pc_overview_daily_key_performance_metrics_explain_median_online_time': 'Median playtime by user during the statistical period.',
  'pc_overview_daily_key_performance_metrics_explain_aot_hour': 'Average daily playtime by user during the statistical period.',
  'pc_overview_daily_key_performance_metrics_explain_above_2hr_users': 'The number of users whose online time exceeds 2 hours during the statistical period.',
  'pc_overview_daily_v2_key_performance_metrics_explain_above_2hr_users': 'The number of new users whose online time exceeds 2 hours during the statistical period.',
  'pc_overview_daily_key_performance_metrics_explain_median_session_time': 'Median session time during the statistical period.',
  'pc_overview_daily_key_performance_metrics_explain_avg_session_time': 'Average daily session time during the statistical period.',
  'pc_overview_daily_key_performance_metrics_explain_avg_session_cnt': 'The average number of sessions per user per day during the statistical period.',
  'pc_overview_daily_key_performance_metrics_explain_pcu_active_users_rate': 'Peak concurrent users/Daily active users.',
  'pc_overview_daily_key_performance_metrics_explain_acu': 'Average concurrent users.',
  'pc_overview_daily_key_performance_metrics_explain_stickiness': 'DAU/WAU(Last 7 days)',
  'pc_overview_daily_key_performance_metrics_explain_active_retention_d2t1': 'The retention rate of active users  on day 1.\\nD1:Number of retained users on day 1 from statistical date/ Number of active users on statistical date date.\\nDate more than 1 day shows average D1. Sum of retention users on day1 in the statistical period / Sum of active users in the statistical period.\\nT-1 means the day before the statistics day.\\nFor example, the statistical date T is 20230806, then Day 0 is 20230806, and Day 1 is 20230807；\\nT-1 is 20230805, and D1(T-1) is the D1 of 20230805；',
  'pc_overview_daily_key_performance_metrics_explain_active_retention_d8t7': 'The retention rate of active users  on day 7.\\nD7:Number of retained users on day 7 from  statistical date/ Number of active users on statistical date date. \\nDate more than 1 day shows average D7. Sum of retention users on day7 in the statistical period / Sum of active users in the statistical period.\\nT-7 means 7 days before the statistical date.\\nFor example, the statistical date T is 20230806, then Day 0 is 20230806, and Day 7 is 20230813；\\nT-7 is 20230730, and D7(T-7) is the D7 of 20230730；',
  'pc_overview_area_mtx_revenue_table_header2_sum($)': 'Sum In-Game Revenue({unit})',
};
